// JWT Configuration for moderator/auth tokens (e.g. generateModeratorToken)
export const jwtConfig = {
  secret: process.env.REACT_APP_JITSI_JWT_SECRET || process.env.JWT_APP_SECRET || null,
  expiresIn: 7200 as const,
  algorithm: 'HS256' as const,
  audience: process.env.REACT_APP_JITSI_APP_ID || 'biblenow',
  issuer: process.env.REACT_APP_JITSI_APP_ID || 'biblenow',
  domain: process.env.REACT_APP_JITSI_DOMAIN || 'stream.biblenow.io',
  // Room name prefix for moderators (optional)
  roomPrefix: 'moderator-',
  // Roles allowed to be moderators
  moderatorRoles: ['moderator', 'admin'] as const
};

export const canBeModerator = (role: string): boolean =>
  jwtConfig.moderatorRoles.includes(role as any);

export const generateModeratorRoomName = (baseRoomName: string): string => {
  return `${jwtConfig.roomPrefix}${baseRoomName}`;
}; 